import React, { Component, useEffect, useState } from 'react';
import { ConfiguratorVariable } from '.';
import { HelpImageContainer, HelpImageViewer, HtmlComponent, SvgImage } from '../../../../components';
import { getUnit, isRequiredAndUnselected, isValidWithValidityInfo, showAccessoryForLanguage, isRequired } from '../../../../util';
import classNames from 'classnames';
import { PropTypes } from 'prop-types';
import { CloseLightIconNew, ErrorIconNew, OrangeWarningIconNew, closeIcon, closePopup } from '../../../../../style/images';
import { translate } from '../../../../services';
import { connect, useSelector } from 'react-redux';
import { combineDispatchers, flagDispatcher, flagState } from '../../../../store';
import { Box, Dialog,IconButton as MuiIconButton } from '@mui/material';
import $ from 'jquery';

const Variable = ( { lang, onChange, onRemove, path, removable, variable, disableRemoveMethod, className, index,configurableProduct,bom  } ) => {
  const [selectedValue, setSelectedValue] = useState(variable.assignedValue?variable.assignedValue.title:variable.title);
  const remove = () =>{setSelectedValue(variable.title); removable && onRemove( variable, variable.assignedValue, `${path}.${variable.name}` );flags.callRemoveMethodForConfigurator&&disableRemoveMethod()};
  const change = ( ...args ) => {onChange( ...args, `${path}.${variable.name}`, variable, index );};
  const flags = useSelector((state)=>state.flags)

  if(flags.callRemoveMethodForConfigurator && flags.selectedVariable===variable.properties.EN){
    remove();
  }

  return <div className="variable-actions">
    <ConfiguratorVariable variable={ variable } selectedValue={selectedValue} setSelectedValue={setSelectedValue} onChange={ change } lang={ lang } removable={removable} className={className} configurableProduct={configurableProduct} bom={bom}/>
    <div className="delete-icon">
      <SvgImage 
        source={ CloseLightIconNew } 
        className={ classNames( { 'hidden': !removable } ) } 
        toolTip={ translate( 'Remove assignment' ) }
        onClick={ remove }
      />
    </div>
  </div>;
};

const isRemovable = (variable,bom) => {
  if ( !variable.assignedValue ) {
    return false;
  }
  if ( variable.assignedValue.state !== 1 ) {
    return false;
  }
  if ( isRequired( variable ) && variable.values.filter( value => value.state !== 4 || value.state !== 1   ).length === 1 ) {
    return false;
  }
  if ( variable.properties && variable.properties.ReadOnly ) {
    return false;
  }
   bom?.forEach(b=>{if(b?.configuredAcc && b?.name==variable.assignedValue.name && b?.identifier==variable.assignedValue.fullyQualifiedName.split('.')[0]){
    return false;
  }})
  return true;
};

export class ConfiguratorGroupComponent extends Component {

  constructor(props){
    super(props);

    this.state = {
      showImage: false,
      image: null,
      selectedVariable: null,
    }
  }
  getClassName( className, variable, key ) {
    const { validityInfo } = this.props;
    return classNames( className, { 'required': isRequiredAndUnselected( variable ), 'error': !isValidWithValidityInfo( variable, validityInfo ) }, `row-${key}` );
  }

  setImage = (image, selectedVariable)=>{
    this.setState({showImage:true, image:image, selectedVariable:selectedVariable})
  }
  closeImage = ()=>{
    this.setState({showImage:false})
  }

  updateSelection = (variables) =>{
    if(this.props.selectedAccessorySelections && this.props.selectedAccessorySelections.length>0){
      let updatedList = this.props.selectedAccessorySelections.filter((selected)=>{
        let variable = variables.find(v=>v.fullyQualifiedName===selected.key);
        return variable && variable.assignedValue?.name===selected.value;
      });
      console.log(updatedList);
      this.props.handleSelectedAccessorySelections(updatedList, "update")
    }
  }
  getDropDownPosition(key) {
    // let dropDownHeight = 42;
    // let size = this.props.variables.filter( showAccessoryForLanguage( this.props.lang ) ).length
    // let totalSize = (size-2)*42+(size-3)*20+60;
    // if(key===size-1){
    //   if ($('.configurator-content').height() - totalSize < dropDownHeight) {
    //     return 'dropup';
    //   }
    // }
    return 'dropdown';
  }

  render() {
    const { children = [], lang, onChange, onRemove, selectorName, path, validityInfo, variables ,configurableProduct,bom,templateKey } = this.props;

    const childGroups = children
    .filter( child => child.show && (child.variables.length>0?child.variables.any( variable => showAccessoryForLanguage( lang )( variable ) ):true) )
    .map( (child,index) => 
        <div key={ child.title+index } className="field-set">
          <h3 key = {child+index} style={{display: "inline-block",fontSize: "15px",fontWeight: 'bold'}}>{ child.title }</h3>
          <ConfiguratorGroup 
            path={ child.fullyQualifiedName } 
            children={ child.children } 
            variables={ child.variables } 
            lang={ lang } 
            onChange={ onChange } 
            onRemove={ onRemove } 
            validityInfo={ validityInfo }
            selectorName={ selectorName }
            configurableProduct ={configurableProduct}
            bom={bom}
            templateKey={templateKey }
          />
        </div> 
      );
    
    this.props.mainProductChanged && this.props.fromModelConfiguratorSelector && this.updateSelection(variables);

    const variableComponents = variables.filter( showAccessoryForLanguage( lang ) ).map( (variable, key) => {
      const label = variable.title + getUnit( variable, variables );
      const title = isRequiredAndUnselected( variable ) ? translate( 'Is required' ) : label;
      const removable = isRemovable( variable,bom ); 
      const className = this.getClassName( 'variable', variable, key )

      return <div key={ variable.name+key } className={ className }>
        {className.includes("error")?
        <div className="variable-error">
          <div className="error-icon">
          <Box component="img" src={ErrorIconNew} sx={{width:'16px', height:'16px'}}></Box>
          </div>
          <div className="error-varibale">
            <HtmlComponent item={ label } tooltip={ title } type="span" className="p"/>
            <HelpImageViewer selectorName={ selectorName } filterName= { variable.name } displayName={ label } defaultFilter={variable.properties?.EN} image={this.state.image} setImage={this.setImage} templateKey={templateKey}/> 
            <Variable lang={ lang } onChange={ onChange } onRemove={ onRemove } path={ path } removable={ removable } variable={ variable } disableRemoveMethod={this.props.disableRemoveMethodForConfigurator
                      } configurableProduct={configurableProduct} bom={bom}/>
          </div>
        </div>:
        className.includes("required")?<div className="variable-required">
          <div className="warning-icon">
          <Box component="img" src={OrangeWarningIconNew} sx={{width:'16px', height:'16px'}}></Box>
          </div>
          <div className="required-varibale">
            <HtmlComponent item={ label } tooltip={ title } type="span" className="p"/>
            <HelpImageViewer selectorName={ selectorName } filterName= { variable.name } displayName={ label } defaultFilter={variable.properties?.EN} templateKey={templateKey} image={this.state.image} setImage={this.setImage}/> 
            <HelpImageViewer selectorName={ selectorName } filterName= { variable.name } displayName={ label } defaultFilter={variable.properties?.EN } templateKey={templateKey} secondImage={true} setImage={this.setImage} /> 
	    <Variable lang={ lang } onChange={ onChange } onRemove={ onRemove } path={ path } removable={ removable } variable={ variable } disableRemoveMethod={this.props.disableRemoveMethodForConfigurator
                      } configurableProduct={configurableProduct} bom={bom}/>
          </div>
        </div>:<div className='field'>
          <div className='label'>
            <HtmlComponent item={ label } tooltip={ title } type="span" className="p"/>
            <HelpImageViewer selectorName={ selectorName } filterName= { variable.name } displayName={ label } defaultFilter={variable.properties?.EN} templateKey={templateKey} image={this.state.image} setImage={this.setImage}/> 
            <HelpImageViewer selectorName={ selectorName } filterName= { variable.name } displayName={ label } defaultFilter={variable.properties?.EN } templateKey={templateKey} secondImage={true} setImage={this.setImage} /> 
        </div>
        <Variable index={key} lang={ lang } onChange={ onChange } onRemove={ onRemove } path={ path } removable={ removable } variable={ variable } disableRemoveMethod={this.props.disableRemoveMethodForConfigurator
                  } className={'dropdown'} configurableProduct={configurableProduct} bom={bom}/>
                  </div>
                  }
      {/* to show help image for model configurators */}
      {this.state.selectedVariable===variable.name && <Dialog open={this.state.showImage} sx={{width:"100%", height:"100%", padding:'32px'}} onClose={this.closeImage} PaperProps={{className:"help-image-dialog", sx:{
                  display: 'inline-flex',
                  // padding: "32px 24px",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "24px",
                  borderRadius: "4px",
                  background: "#FFF",
                  overflow:"hidden",
                  margin:"0px",
                  height:{md:"100%",xs:"max-content"},
                  width:{md:"100%",xs:"max-content"},
                  maxWidth:"100%",
                  maxHeight: "100%"
                }}}>
                    <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.closeImage} style={{width:"24px", height:"24px"}} sx={{display:"flex",position:"absolute", top:"12px", right:"12px", background:"#F5F5F5", height:"20px", width:"20px", borderRadius:"56px" , backgroundColor: 'white'}}>
                            <Box component="img" src={closePopup} style={{width: '24px', height: '24px'}} sx={{height:"16px", width:"24px"}}></Box>
                          </MuiIconButton>
                      {/* <Box component="img" src={closePopup} onClick={this.closeImage} sx={{fill:"#868686", width:"24px", height:"24px", position: "absolute",
                        right: "12px",
                        top: "12px"}}></Box> */}
                                <HelpImageContainer filterName= { variable.title } image={ this.state.image } onClose={this.closeImage}/>  
                  </Dialog>}
      </div>; 
    } );
    if(variables){
      return [ variableComponents,childGroups ];
    }
    return [ childGroups, variableComponents ];
  }
}

ConfiguratorGroupComponent.propTypes = {
  children: PropTypes.arrayOf( PropTypes.object ), 
  lang: PropTypes.string.isRequired, 
  onChange: PropTypes.func.isRequired, 
  path: PropTypes.string.isRequired, 
  validityInfo: PropTypes.shape( {} ), 
  variables: PropTypes.arrayOf( PropTypes.shape( {
    name: PropTypes.string.isRequired,
    properties: PropTypes.shape( {} ),
    title: PropTypes.string.isRequired
} ) )
};

export const ConfiguratorGroup = connect(null,combineDispatchers(flagDispatcher))(ConfiguratorGroupComponent)